import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { toast } from "react-toastify";
import suppliesApi from "../../constants/suppliesApi";
import { AuthUserContext, withAuthentication } from "../Auth/Session";
import CreateModal from "./CreateModal";
import HistoryModal from "./HistoryModal";

const Odometer = ({ t }) => {
  const [odometers, setOdometers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [registerModal, setRegisterModal] = useState(false);
  const [odometerSelected, setOdometerSelected] = useState({
    id: null,
    code: null,
    vehicle: null,
  });

  useEffect(() => {
    getOdometers();
  }, []);

  useEffect(() => {
    if (odometerSelected.id) {
      setShowModal(true);
    }
  }, [odometerSelected.id]);

  const getOdometers = () => {
    trackPromise(
      suppliesApi
        .getOdometersByCustomer(localStorage.getItem("GlobalCustomerId"))
        .then((res) => {
          setOdometers(res);
        })
        .catch((err) => {
          toast.error(err.response.data.detail);
        })
    );
  };

  return (
    <AuthUserContext.Consumer>
      {(authUser) => (
        <div>
          <div className="container-fluid mt-100">
            <div className="row">
              <div className="col-md-8">
                <h3>Listado de Odometros</h3>
              </div>
              <div className="col-md-4">
                <input
                  className="form-control"
                  type="text"
                  id="search"
                  placeholder={t("globals.search-input")}
                />
              </div>
            </div>
            {!!authUser.permissions.create ? (
              <button
                className="btn btn-primary"
                onClick={() => setRegisterModal(true)}
              >
                {t("globals.register")}
              </button>
            ) : null}
            <div className="text-center v-scroll mt-5">
              <table className="table table-striped table-bordered table-sm mb-0">
                <thead>
                  <tr>
                    <th scope="col">Codigo</th>
                    <th scope="col">Kilometraje Actual</th>
                    <th scope="col">Vehiculo</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {odometers.map((odometer) => (
                    <tr key={odometer.id}>
                      <td className="p-2">{odometer.code}</td>
                      <td className="p-2">{odometer.current_km}</td>
                      <td className="p-2">{odometer.vehicle}</td>
                      <td className="p-2">
                        {odometer.vehicle ? "Asignado" : "No asignado"}
                      </td>
                      <td className="p-2">
                        <button
                          className="btn btn-primary"
                          onClick={() => setOdometerSelected(odometer)}
                        >
                          Historial
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {showModal ? (
            <HistoryModal
              open={showModal}
              hidde={() => {
                setShowModal(false);
                setOdometerSelected({
                  id: null,
                  code: null,
                  vehicle: null,
                });
              }}
              odometer={odometerSelected}
            />
          ) : null}
          {registerModal ? (
            <CreateModal
              open={registerModal}
              hide={() => {
                setRegisterModal(false);
              }}
              getData={getOdometers}
            />
          ) : null}
        </div>
      )}
    </AuthUserContext.Consumer>
  );
};

export default withAuthentication(Odometer);
